/**
 * Check if a pixel position is within the defined range.
 */
export function isInPixelRange(
  position: number,
  start: number,
  span: number,
): boolean {
  return position >= start && position <= start + span;
}
